module.exports = __webpack_public_path__ + "static/img/yinpiaokuaitie.cf20d71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/yinpiaokuaitie.png
// module id = eGGL
// module chunks = 70